import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import HylyDropDown from 'storybookComponents/HylyDropDown'
import SearchBox from 'components/SearchBox'
import Box from '@material-ui/core/Box'
import moment from "moment"
import "moment-timezone"


export const parseDateTimeToString = (startAt, endAt, timezoneOffset) => {
  let start = moment(startAt).utcOffset(timezoneOffset);
  let end = moment(endAt).utcOffset(timezoneOffset);
  const date = start.format("MMM DD, YYYY, ");
  const startTime = start.format("hh:mm a");
  const endTime = end.format("hh:mm a");
  let datStr = date + startTime + " - " + endTime;
  return { dateTime: datStr }
}


const getPropertiesRows = (d, classes, timezoneString) => {
  return d.map(item => {
    const obj = parseDateTimeToString(item.startAt, item.endAt, timezoneString)
    return {
      propertyName: <Typography className={classes.tableText}>{item.propertyName}</Typography>,
      title: <Typography>
        <Typography className={classes.tableText}>
          {item.title}
        </Typography>
        <Typography className={classes.eventTime}>
          {obj.dateTime}
        </Typography>
      </Typography >,
      maxNoOfGuests: <Typography className={classes.tableText}>
        {item.maxNoOfGuests > 0 ? item.maxNoOfGuests : "--"}
      </Typography>,
      rsvpedCount: <Typography className={classes.tableText}>
        {item.rsvpedCount > 0 ? item.rsvpedCount : "--"}
      </Typography>,
      waitlistedCount: <Typography className={classes.tableText}>
        {item.waitlistedCount > 0 ? item.waitlistedCount : "--"}
      </Typography>,
      canceledCount: <Typography className={classes.tableText}>
        {item.canceledCount > 0 ? item.canceledCount : "--"}
      </Typography>,

      attendedCount: <Typography className={classes.tableText}>
        {item.attendedCount > 0 ? item.attendedCount : "--"}
      </Typography>,
      notAttendedCount: <Typography className={classes.tableText}>
        {item.notAttendedCount > 0 ? item.notAttendedCount : "--"}
      </Typography>,
    }
  })
}



const csvHeadersProperties = [
  { label: "Property", key: "propertyName" },
  { label: "Events", key: "title" },
  { label: "Capacity", key: "maxNoOfGuests" },
  { label: "RSVPed", key: "rsvpedCount" },
  { label: "Waitlisted", key: "waitlistedCount" },
  { label: "Canceled", key: "canceledCount" },
  { label: "Attended", key: "attendedCount" },
  { label: "Not Attended", key: "notAttendedCount" },
]


const getColumnsForProperties = (classes) => {
  return [
    {
      field: 'propertyName', fieldName: 'Property', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell
    },
    { field: 'title', fieldName: 'Events', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell },
    {
      field: 'maxNoOfGuests', fieldName: '# Capacity', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell
    },
    {
      field: 'rsvpedCount', fieldName: '# RSVPed', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell
    },
    {
      field: 'waitlistedCount', fieldName: '# Waitlisted', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell
    },
    {
      field: 'canceledCount', fieldName: '# Canceled', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell
    },
    {
      field: 'attendedCount', fieldName: '# Attended', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell
    },
    {
      field: 'notAttendedCount', fieldName: '# Not Attended', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCell
    }
  ]

}

const csvHeadersInvitees = [
  { label: "Full Name", key: "fullName" },
  { label: "Status", key: "inviteeStatus" },
  { label: "Cancel Reason", key: "rsvpCancelReason" },
]

const statusDetails = {
  "Attended": {
    color: "#26BBED"
  },
  "Removed From Waitlist": {
    color: "#66D184",
  },
  "Canceled": {
    color: "#F5A623",
  },
  "Canceled By Organiser": {
    color: "#999999",
  },
  "Waitlisted": {
    color: "#333333",
  },
  "Not Attended": {
    color: "#E75F75",
  },
}

const getRowsInvitees = (d, classes) => {
  return d.map(item => {
    const statusData = statusDetails[item.inviteeStatus];
    return {
      fullName: <Typography className={classes.tableText}>{item.fullName}</Typography>,
      status: <Typography className={clsx(classes.tableText, classes.boldText)} style={{
        color: statusData.color
      }}>{item.inviteeStatus}</Typography>,
      rsvpCancelReason: <Typography className={classes.tableText}>
        {item.rsvpCancelReason ? item.rsvpCancelReason : "--"}
      </Typography>,
    }
  })
}


const getColumnsInvitees = (classes, handleFilterProperty, handleFilterStatus, handleFilterReason) => {
  return [
    {
      field: 'fullName', fieldName: 'Invitee', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <SearchBox
          onSearch={handleFilterProperty}
          searchType="auto"
          placeholder=""
        />
      </Box>
    },
    {
      field: 'status', fieldName: 'Status', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <HylyDropDown
          className={classes.dropDown}
          classes={{
            select: classes.dropDownSelect
          }}
          MenuProps={{
            classes: {
              paper: classes.paperRoot
            }
          }}
          propValues={[
            "All",
            "Attended",
            "RSVPed",
            "Canceled",
            "Canceled By Organiser",
            "Waitlisted",
            "Not Attended"
          ]}
          label=""
          multiple={false}
          selectAllEnable={false}
          searchEnable={false}
          onChangeHandler={handleFilterStatus}
        />
      </Box>
    },
    {
      field: 'rsvpCancelReason', fieldName: 'Reason', sortable: true, className: classes.tableHeader, cellClassName: classes.tableCellInvitee, filterable: true, filterField: <Box className={classes.boxStyles}>
        <HylyDropDown
          className={classes.dropDown}
          classes={{
            select: classes.dropDownSelect
          }}
          MenuProps={{
            classes: {
              paper: classes.paperRoot
            }
          }}
          propValues={[
            "All",
            "Temporary Reason",
            "Personal Reason",
            "Out of Station"
          ]}
          label=""
          multiple={false}
          selectAllEnable={false}
          searchEnable={false}
          onChangeHandler={handleFilterReason}
        />
      </Box>
    },
  ]
}

export {
  getPropertiesRows,
  csvHeadersProperties,
  getColumnsForProperties,
  csvHeadersInvitees,
  statusDetails,
  getRowsInvitees,
  getColumnsInvitees
}